import { TFunction } from 'react-i18next';

import { MarginOrderDirection, MarginOrderType } from '@swyftx/margin/build/types';

type Params = {
  t: TFunction<'margin', undefined>;
  tradeSide: MarginOrderDirection;
  tradeType: MarginOrderType;
  symbol?: string;
};

const getSuccessMessage = ({ t, tradeSide, tradeType, symbol }: Params) => {
  if (tradeType === MarginOrderType.Market) {
    return tradeSide === MarginOrderDirection.Long
      ? t('tradeReview.labels.longOpened', { symbol })
      : t('tradeReview.labels.shortOpened', { symbol });
  }

  return tradeSide === MarginOrderDirection.Long
    ? t('tradeReview.labels.longCreated', { symbol })
    : t('tradeReview.labels.shortCreated', { symbol });
};

const getErrorMessage = ({ t, tradeSide, tradeType, symbol }: Params) => {
  if (tradeType === MarginOrderType.Market) {
    return tradeSide === MarginOrderDirection.Long
      ? t('tradeReview.labels.longFailedOpen', { symbol })
      : t('tradeReview.labels.shortFailedOpen', { symbol });
  }

  return tradeSide === MarginOrderDirection.Long
    ? t('tradeReview.labels.longFailedCreate', { symbol })
    : t('tradeReview.labels.shortFailedCreate', { symbol });
};

export { getSuccessMessage, getErrorMessage };
